@if (!!tour) {
<main>
  <un-tour-header [tour]="tour" (book)="book()"></un-tour-header>
  <un-tour-highlight [tour]="tour"></un-tour-highlight>
  <un-tour-info-tabs [tour]="tour" (book)="book()"></un-tour-info-tabs>
  <un-tour-detail-footer
    class="h-md h-lg"
    [tour]="tour"
    (book)="book()"
  ></un-tour-detail-footer>
</main>
}
